<template>
<div class="bottom-nav-kr">
    <v-bottom-navigation  color="teal" grow>
        <v-btn v-for="item in items" :key="item.title" :to="item.to" class="center">
            <span>{{item.title}}</span>
            <v-icon class="v-icon">{{item.icon}}</v-icon>
        </v-btn>

    </v-bottom-navigation>
</div>
</template>

<script>
export default {
    data: () => ({
        // value: 0,
        items: [{
                title: 'Home',
                icon: 'home',
                to: {name:'Home'}
            },
            {
                title: 'Wishlist',
                icon: 'mdi-heart',
                to: {name:'Wishlist'}
            },
            {
                title: 'Orders',
                icon: 'mdi-history',
                to: {name:'Orders'}
            },
            {
                title: 'Payments',
                icon: 'account_balance_wallet',
                to: {name:'Payments'}
            },
            {
                title: 'Profile',
                icon: 'mdi-account',
                to: {name:'Profile'}
            }
        ]
    }),
}
</script>
<style>
.theme--light.v-btn.v-btn--has-bg{background-color:initial!important;}
.v-bottom-navigation{height:initial!important;}
.v-btn--is-elevated{padding:0.7rem 0!important;height:initial!important;}
</style>